<template>
  <BaseModal modal-content-class="modal-achievement locked">
    <div class="banner_top">
      <BaseImage :src="achievementImage" alt="Achievement" />
    </div>

    <div class="content">
      <div class="ach_modal_center">
        <BaseImage src="/static/images/unlocked.svg" alt="Status" />
      </div>

      <h1>{{ $_translations.value[achievementName] }}</h1>

      <div class="unlocked_txt">
        <p>
          {{ $_translations.value[achievementDescription.pt1] }} <br>
          {{ $_translations.value[achievementDescription.pt2] }}
          <span class="yellow_bold">{{ achievementThreshold }}</span>
          {{ $_translations.value[achievementDescription.pt3] }}
        </p>
      </div>

      <div class="flex-row">
        <BaseProgressBar :value="100" />

        <p class="progress_numb">{{ achievementThreshold }} / {{ achievementThreshold }}</p>
      </div>

      <RewardBoxItem
        :prize-value="prizeValue"
        :prize-type="prizeType"
      />
    </div>
  </BaseModal>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { Howl } from 'howler';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseProgressBar from '@/components/bar/BaseProgressBar.vue';
import RewardBoxItem from '@/components/item/RewardBoxItem.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useConfettiHook from '@/hooks/useConfetti.js';
import { getAchievementBadgeImage, getAchievementNameTranslationKey } from '@/helpers/reward.js';
import { achievementCategoryEnum } from '@/constants/reward.js';

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  playSound: {
    type: Boolean,
    default: true,
  },
});

const appSettingsStore = useAppSettingsStore();

const { triggerConfetti, clearConfetti } = useConfettiHook();

const prizeValue = computed(() => props.data?.prizeValue ?? 0);

const prizeType = computed(() => props.data?.prizeType);

const achievementThreshold = computed(() => props.data?.threshold ?? 0);

const achievementImage = computed(() => getAchievementBadgeImage(props.data?.achievementName));

const achievementName = computed(() => getAchievementNameTranslationKey(props.data?.achievementName));

const achievementDescription = computed(() => {
  const category = props.data?.__category;

  if (!Object.values(achievementCategoryEnum).includes(category)) {
    return { pt1: '', pt2: '', pt3: '' };
  }

  return {
    pt1: 'modal_achievement_completed_category_all_description_pt1',
    pt2: `modal_achievement_completed_category_${ category }_description_pt2`,
    pt3: `modal_achievement_completed_category_${ category }_description_pt3`,
  };
});

onMounted(() => {
  triggerConfetti();

  if (appSettingsStore.isSoundEnabled && props.playSound) {
    const modalSound = new Howl({ src: ['/static/sounds/points.mp3'] });
    modalSound.play();
  }
});

onUnmounted(clearConfetti);
</script>
